import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@deporvillage/utils-library-component';

import styles from './Form.module.scss';

const Input = ({
    id, type, value, label, onChange,
}) => {

    const handleOnChange = (e) => onChange && onChange(e.target.value);

    return (
        <div className={styles['form-input']}>
            <input
                className={`${value ? styles['has-value'] : ''}`}
                id={id}
                type={type}
                defaultValue={value || ''}
                onChange={handleOnChange}
                onFocus={undefined}
                placeholder={' '}
                autoComplete={'off'}
            />
            <label htmlFor={id}>
                <I18n>
                    {label}
                </I18n>*
            </label>
        </div>
    );
};

Input.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
};

const Form = (props) => {
    const getForm = () => {
        switch (props.type) {
            case 'password':
                return <Input {...props} />;
            default:
                return null;
        };
    };

    return (
        <div className={`${styles['form-input-wrapper']} ${props.error ? styles.error : ''}`}>
            {getForm()}
            {props.error && <span><I18n>{props.error}</I18n></span>}
        </div>
    );
};

export default Form;
